<div class="smMax:!mt-7 mobi-ui-margin-t-lg view-enter-animation">
  @if (breadcrumb() && breadcrumb()!.length > 1) {
    <div class="mobi-ui-grid is-centered">
      <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
        <nav class="mobi-ui-breadcrumb-major" aria-label="Breadcrumb">
          @if (schema()) {
            <mobi-ld-schema [schema]="schema()" />
          }
          <ol>
            <li>
              <a
                [betterRouterLink]="breadcrumb()![0].url | extractUrl"
                class="flex items-baseline"
                aria-label="Home"
              >
                <span class="flex">
                  <mobi-ui-icon-major name="home" /> <span class="hidden">Home</span>
                </span>
              </a>
            </li>
            @for (
              breadcrumbItem of breadcrumb() | slice: 1;
              track index;
              let index = $index;
              let isCurrentRoute = $last
            ) {
              <li>
                <a
                  [betterRouterLink]="breadcrumbItem.url | extractUrl"
                  [attr.aria-current]="isCurrentRoute ? 'page' : null"
                >
                  {{ breadcrumbItem.title }}
                </a>
              </li>
            }
          </ol>
        </nav>
      </div>
    </div>
  }
</div>
